var styleDataHash = 'd967ab45';  
export const injectCss = (() => {
  var css = `.kVCqE{overflow:auto}.TxZ8t{display:flex;flex-direction:column-reverse}[dir] .mMtSN{margin:0}.PHzoW,.TmpL9{padding:var(--wds-side-panel-content-padding-vertical,18px) var(--wds-side-panel-content-padding-horizontal,24px)}._3Dc68{display:flex;max-height:0;opacity:0;overflow:hidden;transition:max-height .3s ease-out,opacity .1s ease-out}._3Dc68.h9W3o{max-height:250px;opacity:1;overflow:auto;transition:max-height .3s ease-in,opacity .1s ease-in .2s}.NKAhH{overflow:hidden}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "content": "kVCqE",
  "contentScrollReverse": "TxZ8t",
  "label": "mMtSN",
  "padded": "PHzoW",
  "loading": "TmpL9",
  "listWrapper": "_3Dc68",
  "visible": "h9W3o",
  "footer": "NKAhH"
};